import mainFaqData from '../../assets/data/mainFaq.json';
import Footer from '../../components/Footer/Footer';
import styles from './HomeMobile.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import rightArrow from '../../assets/rightArrow.png';
import MainFaqFrameMobile from '../../mobileComponents/MainFaqFrameMobile/MainFaqFrameMobile';
import MainReviewFrame from '../../components/MainReviewFrame/MainReviewFrame';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { loginCheck } from '../../auth/auth';
import ReviewFilter from '../../components/ReviewFilter/ReviewFilter';
import processImage01 from '../../assets/processImage01.png';
import processImage02 from '../../assets/processImage02.png';
import processImage03 from '../../assets/processImage03.png';
import review from '../../assets/review.png';
import ondocServiceM from '../../assets/ondocServiceM.png';
import serviceInfoMobileImg from '../../assets/serviceInfoMobile.png';
import ondocServiceImg from '../../assets/card3-1.png';
import ondocServiceImg2 from '../../assets/card3-2.png';
import ondocServiceImg3 from '../../assets/card3-3.png';
import { IProductListType } from '../../pages/ProductList/ProductList';
import banner10 from '../../assets/banner/mobileMainBanner10.jpeg';
import main1 from '../../assets/main1.png';
import main2 from '../../assets/main2.png';
import mainlogo from '../../assets/mainlogo.png';
import main1m from '../../assets/main1_m.png';
import LazyLoad from 'react-lazy-load';
import { IAdLinkDataType } from '../../pages/Home/Home';
import ADLink from '../../components/ADLink/ADLink';
import { IBannerType } from '../../components/MainBanner/MainBanner';
import Header from '../../components/Header/Header';
import Popup from '../../components/Popup/Popup';
import { useCookies } from 'react-cookie';

const defaultMobileBannerList: IBannerType[] = [
  { image: banner10, url: 'productDetail/1' },
];

const mainFaqList = mainFaqData;

function HomeMobile() {
  const location = useLocation();
  const navigate = useNavigate();
  //배너
  const [activeIdx, setActiveIdx] = useState(0);
  const [processList, setProcessList] = useState<IBannerType[]>([]);
  const { data: apiBannerData = [] } = useQuery<IBannerType[]>(
      'banner-advertisement-mobile',
      async () => {
        return await axiosClient
            .get('/data/banner/advertisement')
            .then((res) =>
                res.data.map((banner: any) => ({
                  image: banner.mobile_image,
                  url: banner.link
                }))
            );
      },
      {
        staleTime: 60000 * 60, // 1 hour cache
      }
  );
  useEffect(() => {
    setProcessList(() => {
      let list: IBannerType[] = [
        { image: processImage01 },
        { image: processImage02 },
        { image: processImage03 },
      ];
      return [...list];
    });
  }, []);
  const slideList = apiBannerData.length > 0 ? apiBannerData : defaultMobileBannerList;
  const [swiper, setSwiper] = useState<SwiperCore>();
  //배너
  //상품
  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      let queryString = '';
      let ids = JSON.parse(
        sessionStorage.getItem('product_ids') || JSON.stringify([]),
      );
      if (ids.length) {
        queryString = 'add_products=';
        ids.map((id: number, idx: number) => {
          queryString += `${id}${idx !== ids.length - 1 ? ',' : ''}`;
        });
      }
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
  );
  //상품
  //프로세스
  const [processSliderIdx, setProcessSliderIdx] = useState(0);
  //프로세스
  //회사소개
  const [infoSwiper, setInfoSwiper] = useState<SwiperCore>();
  const [ondocInfoIndex, setOndocInfoIndex] = useState<number>(1);
  //회사소개
  //의사
  const [doctorSwiper, setDoctorSwiper] = useState<SwiperCore>();
  const [doctorInfoIndex, setDoctorInfoIndex] = useState<number>(1);
  const handleDoctorInfoChange = (doctorSwiper: SwiperCore) => {
    setDoctorInfoIndex(doctorSwiper.realIndex);
  };
  //의사
  const { data: reviewData } = useQuery<IReviewDataType[]>(
    ['main', 'photo_review'],
    () =>
      axiosClient
        .get(
          '/data/product_talk/photo-review-list?&talk_type=상품평가&limit=5&order_by=star',
        )
        .then((res) => res.data.data),
    {
      staleTime: 60000 * 60,
    },
  );
  //review
  //ondocInfo
  const handleOndocInfoChange = (infoSwiper: SwiperCore) => {
    setOndocInfoIndex(infoSwiper.realIndex);
  };

  //기존 상품 url접속시 대응
  useEffect(() => {
    let pn = new URLSearchParams(location.search).get('pn');
    if (!pn) return;
    if (pn == 'product.view') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=N&code=${new URLSearchParams(
            location.search,
          ).get('pcode')}`,
        )
        .then((res) => navigate(res.data.data.url));
    } else if (pn == 'blind_gate') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=Y&code=${new URLSearchParams(
            location.search,
          ).get('bc')}`,
        )
        .then((res) => navigate(res.data.data.url));
    }
  }, []);
  //기존 상품 url접속시 대응
  const [adLinkOpen, setAdLinkOpen] = useState(true);
  const [adLinkData, setAdLinkData] = useState<IAdLinkDataType>();
  // useEffect(() => {
  //   axiosClient.get('/data/product/promotional_product').then((res) => {
  //     if (!Object.keys(res.data.data).length) return;
  //     setAdLinkData(res.data.data);
  //   });
  // }, []);

  const [hasCookie, setHasCookie] = useState(true);
  const [cookies, setCookies] = useCookies();

  useEffect(() => {
    if (cookies['week-close']) setHasCookie(true);
    else setHasCookie(false);
  }, []);

  return (
    <>
      {adLinkOpen && adLinkData && (
        <ADLink
          productId={adLinkData.id}
          productName={adLinkData.product_name}
          price={adLinkData.price}
          discountedPrice={adLinkData.sale_price}
          closer={setAdLinkOpen}
        />
      )}
      {/* {!hasCookie && <Popup />} */}
      <div>
        <Header />
        <div className={styles.heroSection}>
          <img src={main1m} alt="main" className={styles.heroImg} />
          <div className={styles.heroBottom}>
            <p className={styles.heroSubEn}>Online Herbal Diet <br />Prescription</p>
            <p className={styles.heroSubKo}>비대면 다이어트 한약 처방</p>
            <button
              className={styles.heroButton}
              onClick={() => navigate('/productDetail/1')}
            >
              VIEW DETAILS
            </button>
          </div>
        </div>
        {/* <div className={styles.prescriptionProductWrap}>
          <h3 onClick={() => navigate(`/productDetail/1`)}>
            <span>글로우라인 상품</span>
            <img src={rightArrow} alt="rightArrow" />
          </h3>
          <Swiper slidesPerView={1} spaceBetween={20}>
            {productList &&
              productList
                ?.filter((product) => product.is_prescription === 1)
                .map((product, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className={styles.productSlideWrap}
                      onClick={() =>
                        navigate(`/productDetail/1`)
                      }
                    >
                      <div className={styles.productThumbnailWrap}>
                        <img
                          src={product.list_image + '?w=530'}
                          alt="productThumbnail"
                        />
                      </div>
                      <div className={styles.productInfoWrap}>
                        <span className={styles.productTag}>BEST</span>
                        <h3 className={styles.productTitle}>글로우라인 밸런스드 슬리밍</h3>
                        <p className={styles.productDescription}>
                          글로우라인의 8가지 성분이 독창적인 배합 기술로 <br />
                          특허 출원되어 믿을 수 있고 검증된 상품입니다.
                        </p>
                        <button
                          className={styles.productButton}
                          onClick={() =>
                            navigate('/productDetail/1')
                          }
                        >
                          구매하러 가기
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
          </Swiper>
        </div> */}
        <div className={styles.reviewWrap}>
          <h3 onClick={() => navigate(`/review/all`)}>
            <span>글로우라인 실시간리뷰</span>
            <img src={rightArrow} alt="rightArrow" />
          </h3>
          <div className={styles.reviewSliderWrap}>
            <LazyLoad>
              <Swiper
                slidesPerView={1.5}
                spaceBetween={10}
                className={styles.reviewSlider}
                breakpoints={{ 700: { slidesPerView: 2.8 } }}
              >
                {reviewData
                  ?.filter((review) => review.product?.list_image)
                  .map((review) => (
                    <SwiperSlide key={review.id}>
                      <MainReviewFrame review={review} />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </LazyLoad>
            {!loginCheck() && <ReviewFilter borderRadius={0} />}
          </div>
        </div>
        <div className={styles.serviceCards}>
          <div className={styles.serviceCard}>
            <div className={styles.serviceCardImage}>
              <img src={ondocServiceImg} alt="원격 진료" />
            </div>
            <div className={styles.serviceCardText}>
              <span className={styles.serviceCardSub}>시간과 장소의 제약 없는</span>
              <span className={styles.serviceCardTitle}>더 정확하고 더 쉬운<br />비대면 원격 진료</span>
            </div>
          </div>
          <div className={styles.serviceCard}>
            <div className={styles.serviceCardImage}>
              <img src={ondocServiceImg2} alt="처방 배송" />
            </div>
            <div className={styles.serviceCardText}>
              <span className={styles.serviceCardSub}>병원 방문이 어려운 분을 위한</span>
              <span className={styles.serviceCardTitle}>처방부터 수령까지<br />더 간결하게</span>
            </div>
          </div>
          <div className={styles.serviceCard}>
            <div className={styles.serviceCardImage}>
              <img src={ondocServiceImg3} alt="맞춤 치료" />
            </div>
            <div className={styles.serviceCardText}>
              <span className={styles.serviceCardSub}>정성과 과학의 조화</span>
              <span className={styles.serviceCardTitle}>식약처 인증 의약품으로<br />더 안전한 맞춤 치료</span>
            </div>
          </div>
        </div>
        <div className={styles.serviceInfoWrap}>
          <img src={serviceInfoMobileImg} alt="서비스 안내" className={styles.serviceInfoBg} />
          <div className={styles.serviceInfoText}>
            언제 어디서나 편리하게 <br />
            편리하게 건강을 관리하세요<br />
            전통 한방과 최신 기술이 <br />
            조화를 이루는<br />
            <span className={styles.highlight}>글로우라인 비대면 진료</span>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default HomeMobile;
